import styled from 'styled-components/macro';
import { Col, Row } from '@yme/atoms/grid';
import { colorCoreWhite1000, HERO_SECTION_BACKGROUND_SECOND } from '@yme/tokens/colors';
import { elevationBottomLvl4 } from '@yme/tokens/elevations';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { ADAPTIVE } from '@yme/tokens/screen';
import { RegularTextLevel3 } from '@yme/tokens/typography';
import { getTextStyles, transformSrcSetToCss } from '@yme/utils/styles';
export const HiddenWrapperStyled = styled.div `
  opacity: 0;
`;
export const ContentBlockStyled = styled(FlexWrapper) `
  ${ADAPTIVE.minWidth.desktop} {
    box-sizing: border-box;
    transition: transform 0.25s ease-out;
    text-shadow: ${elevationBottomLvl4};

    min-height: 100%;

    // eslint-disable-next-line max-len
    transform: translateY(
      calc(
        ${({ parentCardHeight }) => `${parentCardHeight}px`} - ${({ bottom }) => bottom} -
          ${({ visiblePartHeight }) => `${visiblePartHeight}px`}
      )
    );
  }
`;
export const CardOverlayStyled = styled.div `
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: ${HERO_SECTION_BACKGROUND_SECOND};
`;
export const CardImageStyled = styled.div `
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;

  ${({ srcSet, imageUrl }) => transformSrcSetToCss(srcSet, imageUrl)}
  aspect-ratio: ${({ aspectRatio }) => aspectRatio};
  margin-bottom: ${({ marginBottom }) => marginBottom};
  width: 100%;

  box-shadow: ${elevationBottomLvl4};

  ${ADAPTIVE.minWidth.desktop} {
    box-sizing: border-box;
    overflow: hidden;
  }

  &:hover {
    ${ADAPTIVE.minWidth.desktop} {
      cursor: pointer;
    }
  }

  ${ADAPTIVE.minWidth.desktop} {
    &:hover ${ContentBlockStyled} {
      transform: translateY(
        calc(
          ${({ parentCardHeight }) => `${parentCardHeight}px`} -
            ${({ internalMargin }) => internalMargin} -
            ${({ contentHeight }) => `${contentHeight}px`}
        )
      );
    }

    &:hover ${HiddenWrapperStyled} {
      opacity: 1;
    }
  }
`;
export const DescriptionStyled = styled(RegularTextLevel3) `
  ${getTextStyles(null, null, 14, 20)}

  ${ADAPTIVE.minWidth.tablet} {
    ${getTextStyles(null, null, 16, 24)}
  }
`;
export const RowStyled = styled(Row) `
  margin-left: ${({ internalMargin }) => internalMargin};
  margin-right: ${({ internalMargin }) => internalMargin};
`;
export const CardContentColStyled = styled(Col) `
  position: relative;
`;
export const DescriptionTextStyled = styled.p `
  font-family: 'Ubuntu', sans-serif;
  font-style: normal;
  font-size: 16px;
  line-height: 24px;
  color: ${colorCoreWhite1000};
  display: -webkit-box;
  -webkit-line-clamp: ${({ countLineVisible }) => countLineVisible && countLineVisible};
  -webkit-box-orient: vertical;
  overflow: hidden;
`;
